export function getHeaders(selectDialog = false) {
  const headers = [
    {
      text: 'Invoice Number',
      className: 'fixed-cell left',
    },
    {
      text: 'Ref No',
    },
    {
      text: 'License No',
    },
    {
      text: 'Invoice Date',
    },
    {
      text: 'Customer Code',
    },
    {
      text: 'Customer Name',
    },
    {
      text: 'Customer Phone',
    },
    {
      text: 'Destination',
    },
    {
      text: 'Sale Person',
    },
    {
      text: 'Payment Method',
    },
    {
      text: 'Currency',
    },
    {
      text: 'Total Amount',
    },
    {
      text: 'Other Service Charges',
    },
    {
      text: 'Received Amount',
    },
    {
      text: 'Remaining Balance',
    },
    {
      text: 'Deposit Invoice',
    },
    {
      text: 'actions',
      className: 'fixed-cell',
      width: 120,
    },
  ];

  return headers;
}
